import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'cmps-card-header-row-component',
    template: `
        <div class="cmps-card-header-row-container">
            <div class="cmps-card-header-row-group">
                <cmps-icon
                    *ngIf="isShowingIcon && !isHumanView"
                    svgIcon="__internal:account-circle"
                ></cmps-icon>
                <cmps-icon
                    *ngIf="isShowingIcon && isHumanView"
                    svgIcon="__internal:briefcase-variant"
                ></cmps-icon>
                <div
                    class="cmps-card-header-row-header-title"
                    [innerHTML]="sanitizedLabel"
                ></div>
            </div>
            <h6 class="cmps-card-header-row-header-time-period">
                {{ timePeriod }}
            </h6>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardHeaderRowComponent implements OnChanges {
    @Input() cardHeaderLabel: string;
    @Input() timePeriod: string;

    @Input() isShowingIcon: boolean;
    @Input() isHumanView: boolean;

    sanitizedLabel: SafeHtml;

    constructor(private readonly sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.cardHeaderLabel) {
            this.sanitizedLabel = this.sanitizer.bypassSecurityTrustHtml(
                this.cardHeaderLabel,
            );
        }
    }
}
